import { useEffect, useState, useContext} from 'react';
import { DashboardIds } from './sisense.constants';
import styled from 'styled-components';
import { CircularProgress } from '@material-ui/core';
import firebaseUtil from '../../../data/FirebaseUtil';
import { AuthContext } from '../../../authentication/Auth';



const ContentWrapper = styled.div`
  background-color: white;
  padding: 16px;
`

export const SisenseDashboard = ({tab}) => {
  const [dashboardLoaded, setDashboardLoaded] = useState(false);
  const authContext = useContext(AuthContext);

  useEffect(() => {
    if(localStorage.getItem('sisenseUrl')){
      initializeSisense();
    } else {
      firebaseUtil.getSisenseUrl().then((url) => {
        if(typeof url === 'string'){
          localStorage.setItem('sisenseUrl', url);
          initializeSisense();
        }
      }).catch((error) => {
        console.log('Error in fetching Sisense URL');
    })
  }
  }, [])

  const initializeSisense = () => {
    const url = new URL(window.location.href)
    const params = new URLSearchParams(url.search)
    const dashboardIdFromRoute = params?.get('dashboardId')
    const reportName = window.location.pathname.substring(1)
    if (dashboardIdFromRoute) {
      loadDashboard(dashboardIdFromRoute, reportName)
    } else {
      const dashboardId = DashboardIds[tab]
      loadDashboard(dashboardId, reportName)
    }
  }

  const loadDashboard = (dashboardId, reportName) => {
    if (dashboardId) {
      const isFilterPanelNeeded = !(reportName === null)
      setDashboardLoaded(false)
      getDashboard(
        dashboardId,
       'sisense-iframe',
        isFilterPanelNeeded
      ).then(() => {
        setDashboardLoaded(true)
        resizeIFrame()
      })
    }
  }

  const resizeIFrame = (height) => {
    setTimeout(() => {
      if (height > 0) {
        const iFrame = document.getElementsByTagName('iframe')[0]
        iFrame.style.height = height + 'px'
        iFrame.style.minHeight = '100vh'
        iFrame.style.overflow = 'hidden'
      }
    }, 500)
  }

  const resizeSisenseFrame = (sisenseFrame) => {
    setTimeout(() => {
      sisenseFrame.getSize().then((dashboardSize) => {
        if (dashboardSize.content.height > 0) {
          const iFrame = document.getElementsByTagName('iframe')[0]
          iFrame.style.height = dashboardSize.content.height + 'px'
          iFrame.style.minHeight = '100vh'
          iFrame.style.overflow = 'hidden'
        }
      })
    }, 500)
  }

  const getDashboard = async (
    dashboardId,
    iFrameId,
    showFilterPane
  ) => {
    const sisenseSDK = await connectSisenseSDK()
    const SisenseFrame = sisenseSDK?.SisenseFrame
    const enums = sisenseSDK?.enums
    const sisenseBaseUrl = localStorage.getItem('sisenseUrl');
    const url =
    sisenseBaseUrl +
      '/app/main/dashboards/' +
      dashboardId +
      '?embed=true&r=true&l=false&t=false&h=false&'
    if (SisenseFrame && enums) {
      const sisenseFrame = new SisenseFrame({
        url,
        dashboard: dashboardId,
        settings: {
          showToolbar: false,
          showLeftPane: false,
          showRightPane: showFilterPane
        },
        element: document.getElementById(iFrameId)
      })

      const iframeElement = document.getElementsByTagName('iframe')[0]
      if (iframeElement) {
        iframeElement.addEventListener('load', () => {})
      }

      sisenseFrame.dashboard.on(enums.DashboardEventType.LOADED, () => {
        resizeSisenseFrame(sisenseFrame)
      })

      sisenseFrame.dashboard.on(enums.DashboardEventType.SIZECHANGED, () => {
        resizeSisenseFrame(sisenseFrame)
      })

      return sisenseFrame.render().then(() => {
        console.log(`Dashboard ${dashboardId} loaded!`)
      })
    }
  }

  const addSisenseSDK = async () => {
    return new Promise((resolve) => {
      if (!document.getElementById('sisenseSDKScript')) {
        const url = localStorage.getItem('sisenseUrl')
        const tag = document.createElement('script')
        tag.src = url + '/js/frame.js'
        tag.id = 'sisenseSDKScript'
        tag.type = 'text/javascript'
        tag.onload = () => {
        const { email } = authContext.currentUser;
          firebaseUtil.setSisenseDataSecurityRules({email}).then(
            () => {
              resolve(true)
            },
            () => {
              resolve(true)
            })
        }
        document.getElementsByTagName('body')[0].appendChild(tag)
      } else {
        resolve(true)
      }
    })
  }

  const connectSisenseSDK = async () => {
    const addScript = await addSisenseSDK()
    if (addScript) {
      return window['sisense.embed']
    }
    return null
  }

  return (
    <>
      <ContentWrapper>
        {!dashboardLoaded && (
          <div style={{position: 'absolute', top: '50%', left: '60%'}}>
            <CircularProgress />
          </div>
        )}
          <div className="p-3">
            <iframe
              id="sisense-iframe"
              frameBorder="0"
              scrolling="no"
              title="Sisense Dashboard"
            ></iframe>
          </div>
      
      </ContentWrapper>
    </>
  )
}
